// extracted by mini-css-extract-plugin
export default {"vertical-icon":"styles_vertical-icon__QswfZ","card-link":"styles_card-link__JvIWr"};